export default {"src":"/_next/static/media/Logo_Placeholder.c6bc098a.svg","height":173,"width":289,"blurWidth":0,"blurHeight":0};